export const categories = [
  {
    id: "cat-1",
    name: "热门推荐",
    slug: "hot",
    description: "精选热门内容，每日更新最受关注的精彩文章",
    icon: "ri-fire-line",
  },
  {
    id: "cat-2",
    name: "最新资讯",
    slug: "news",
    description: "第一时间获取最新资讯和行业动态",
    icon: "ri-newspaper-line",
  },
  {
    id: "cat-3",
    name: "深度解读",
    slug: "deep-read",
    description: "深度剖析热点话题，提供专业视角分析",
    icon: "ri-lightbulb-line",
  },
  {
    id: "cat-4",
    name: "精品原创",
    slug: "original",
    description: "优质原创内容，独家打造的高品质阅读体验",
    icon: "ri-quill-pen-line",
  },
  {
    id: "cat-5",
    name: "教程指南",
    slug: "tutorial",
    description: "实用教程和操作指南，助你快速上手",
    icon: "ri-book-open-line",
  },
  {
    id: "cat-6",
    name: "互动讨论",
    slug: "discussion",
    description: "热门话题讨论区，分享观点碰撞思想",
    icon: "ri-chat-3-line",
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});